import * as Yup from 'yup';

import { ContactInfoSchema } from './contact-info.schema';
import { ThirdPartySchema } from './third-party.schema';

// The civility is a reference the back does not check: an empty one would be saved as a random
// id.
export const PersonSchema = ThirdPartySchema.shape({
  civilityId: Yup.string().required('La civilité est requise'),
  contactInfo: ContactInfoSchema.nullable(),
});
